// @flow

import {normalize} from './util'

// ---------------------------------------------------
// Some constants are static data that are output from
// the app on boot.
// They are bound here to use in the app.
// When binding, the lists (arrays) are converted to
// dictionaries (objects) for direct access.
// The lists remain accessible through the
// List suffix in the name:
// - VATTypeList
// ---------------------------------------------------

const getAuxData = (type: string, defaultValue: any): any =>
  window.menageConfig.aux && window.menageConfig.aux[type]
    ? window.menageConfig.aux[type]
    : defaultValue

export const VATTypeList: any[] = getAuxData('vatTypes', [])
export const VATTypes: any = normalize(VATTypeList)

export const CommissionTypeList: any[] = getAuxData('commissionTypes', [])
export const CommissionTypes: any = normalize(CommissionTypeList)

export const BABY_STATES = getAuxData('babyStates', [])
export const COUNTRIES = ['BE', 'FR', 'GB', 'NL', 'DE', 'LU']

export const GENERIC_DATE_FORMAT = 'DD/MM/YYYY'
export const FULL_DATE_FORMAT = 'DD/MM/YYYY - HH:mm'
export const SHORT_DATE_FORMAT = 'DD/MM'
